/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_How_We_Work_DescriptionInputs */

const en_meta_how_we_work_description = /** @type {(inputs: Meta_How_We_Work_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How we deliver AI systems: understand the work, scope a first phase, build something your team can test, launch with agreed limits and keep it improving.`)
};

const lv_meta_how_we_work_description = /** @type {(inputs: Meta_How_We_Work_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kā izstrādājam AI sistēmas: izprotam darbu, nosakām pirmo posmu, izveidojam sistēmu, ko komanda var pārbaudīt, ieviešam ar saskaņotām robežām un turpinām uzlabot.`)
};

/**
* | output |
* | --- |
* | "How we deliver AI systems: understand the work, scope a first phase, build something your team can test, launch with agreed limits and keep it improving." |
*
* @param {Meta_How_We_Work_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_how_we_work_description = /** @type {((inputs?: Meta_How_We_Work_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_How_We_Work_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_how_we_work_description(inputs)
	return en_meta_how_we_work_description(inputs)
});